import { List } from '@salecycle/ui-component-library';
import { FC } from 'react';
import Infinite from 'react-infinite';
import ClientListItem from './ClientListItem';

interface Props {
  clientLevel: string;
  siteIds: string[];
  brandIds: string[];
  groupIds: string[];
}

export const ClientList: FC<Props> = props => {
  const ids = getContextClientLevelIds(props);
  if (ids && ids.length > 0) {
    return (
      <List>
        <Infinite
          containerHeight={window.innerHeight - 283} // Height of area available minus top bar, search, box padding etc. plus 40 for padding
          elementHeight={57} // Height of list item (incl padd margin)
          timeScrollStateLastsForAfterUserScrolls={10}
        >
          {ids.map((id, n) => (
            <ClientListItem key={`client-${id}-${n}`} id={id} clientLevel={props.clientLevel} />
          ))}
        </Infinite>
      </List>
    );
  }
  return null;
};

function getContextClientLevelIds(props: Props) {
  if (props.clientLevel === 'sites') {
    return props.siteIds;
  } else if (props.clientLevel === 'groups') {
    return props.groupIds;
  } else {
    return props.brandIds;
  }
}

export default ClientList;
